import React, { useEffect } from 'react';
import { TailSpin } from 'react-loading-icons';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import XAPiTLogo from '../../assets/xapit_logo_135.png';
import { postVerification } from '../../utils/api/functions/signup';

const Verification = () => {

    const {email, token, code} = useParams(); 

    useEffect(() => {
        if(!code || !token) return;
        postVerification(token, code).then((res) => {
            console.log(res); 
            if(res.status_code === 200){
                console.log("Verification successful", res?.body?.message);
                toast.success("Verification successful, redirecting to login...");
                setTimeout(() => {
                    window.location.href = "/login";
                }, 1500); 
            } else {
                console.error("Verification failed", res?.body?.message);
                if(res?.body?.message) toast.error(res?.body?.message); 
                else toast.error("Verification failed, please contact support");
            }
        }).catch((err) => {
            console.error("Error during verification",  err);
            toast.error("Error during verification, please contact support"); 
        })
    }, [code, token])

    return(
        <div className="signup-container">
            <div className="signup-welcome" style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%", 
                height: "100%"
            }}>
                <img src={XAPiTLogo} alt="XAPiT Logo" style={{}} />
                <h3>Verifying your email, please wait...</h3>
                <div>
                    <TailSpin stroke="#2dbcd3" fill="#2dbcd3" speed={1} width="50px" height="50px" />
                </div>
            </div>
        </div>
    )
}


export default Verification; 